import * as actionTypes from './actionTypes';
import * as userService from './service'
import { syncHubSessionsWithLogin } from '../../../Util/hubSessionConfig'

const log = require("loglevel").getLogger("UserActions");
log.setLevel("debug");
export const sendtwoFAcode = (user, callback) => {
	
	return async (dispatch) => {
		log.debug("UserActions -> send2FA -> Enter");
		const result = await userService.sendtwoFA(user);
		if(result == null) {
			callback('failed');
		} else {
			callback('ok');
		}
	}
}
// (user, callback): a "chkRememberMe" second argument was taken here and never used; the
// login page's "Remember Me" box was removed with it (2026-10-27).
export const signIn = (user, callback) => {
	// SEC-06: logged the plaintext password.
	// return;
	return async (dispatch) => {
		log.debug("UserActions -> signIn -> Enter");

		const result = await userService.signIn(user);
		// "failed" = wrong email or password; "refused" = an account the backend turned away
		// (pending approval, collaborator, property manager); "error" = anything else.
		if(result == null) {
			callback('failed');
		}
		else if (result.refused) {
			callback('refused');
		}
		else if (result.error) {
			callback('error');
		}
		else {
			// SEC-06: logged the whole login response, including the JWT.
			localStorage.setItem("jToken", result.token);
			// New login: drop hub sessions issued before it (e.g. a public one from /login).
			syncHubSessionsWithLogin();
			//props.setToken(result.data.token);
			localStorage.setItem("id", result.agent._id);
			localStorage.setItem("agent_id", result.agent.agent_id);
			localStorage.setItem("agency_id", result.agent.agency_id);
			//props.setUser(result.data.agent);
			// add check that agency_id exists on /get-travel-agencies
			localStorage.setItem("agent", JSON.stringify(result.agent));

			await dispatch ({
				type: actionTypes.USER_LOGGED_IN,
				data: user
			});
			callback('ok');
		}
	}
};

export const toggleSideBar = (status) => {
	return async (dispatch) => {
		log.debug(`UserActions -> toggleSidebar -> ${status}`);
		await dispatch ({
			type: actionTypes.TOGGLE_HIDDEN_SIDEBAR,
			data: status
		});
	}
};

// The left menu, wide or narrowed to icons (VT review 7/8). The choice is kept for the next
// visit by the menu itself (Util/sidebarPrefs.js).
export const setSideBarCollapsed = (collapsed) => {
	return {
		type: actionTypes.SET_SIDEBAR_COLLAPSED,
		data: Boolean(collapsed)
	}
};

export const setOnboardingStep = (step) => {
	return {
		type: actionTypes.SET_ONBOARDING_STEP,
		data: step
	}
};

export const setOnboardingComplete = () => {
	return {
		type: actionTypes.SET_ONBOARDING_COMPLETE
	}
};

export const setWalkthroughSeen = () => {
	return {
		type: actionTypes.SET_WALKTHROUGH_SEEN
	}
};

export const signUp = (agent, callback) => {
	return async (dispatch) => {
		log.debug("UserActions -> signUp -> Enter");

		const result = await userService.signUp(agent);
		if(result == null) {
			callback('failed');
		}
		else {
			callback('ok', result);
		}
	}
};

export const setLoggedInUser = user => {
	return {
		type: actionTypes.USER_LOGGED_IN,
		data: user
	}
};

export const forgotPassword = email => {
	return async (dispatch) => {
		log.debug("UserActions -> forgotPassword -> Enter");
		await userService.forgotPassword(email);
	}
};


export const signOut = () => {
	return async (dispatch) => {
		log.debug("UserActions -> signOut -> Enter");

		localStorage.removeItem("agent");


		await dispatch ({
			type: actionTypes.USER_LOGGED_OUT
		});
	}
};
